import React from 'react';
import { PhoneIcon, MessageCircleIcon, SendIcon } from 'lucide-react';
import { Language, translations } from '../utils/translations';
export function ContactSection({
  lang
}: {
  lang: Language;
}) {
  const t = translations[lang];
  return <section aria-labelledby="contact-title" data-id="element-63" data-mp="2klgs80iniqmv">
      <h2 id="contact-title" className="mb-5 text-center text-[19px] font-bold tracking-[-0.03em] text-zinc-50" data-id="element-64" data-mp="2pigvk3o49faa">
        {t.contactTitle}
      </h2>
      <div className="space-y-3" data-id="element-65" data-mp="3d8uk3k7hsw04">
        <a href="tel:+380971234567" className="contact-row bg-zinc-900 text-zinc-100 hover:bg-zinc-800 border-transparent" data-id="element-66" data-mp="3i7e2xbqshro9">
          <span className="contact-icon bg-zinc-800 text-gold-500" data-id="element-67" data-mp="346v1ingtxjv2">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="388otm7cylfjm" />
          </span>
          +38 (097) 123-45-67
        </a>
        <a href="viber://chat?number=%2B380971234567" className="contact-row bg-zinc-900 text-zinc-100 hover:bg-zinc-800 border-transparent" data-id="element-69" data-mp="1srog9890br9k">
          <span className="contact-icon bg-zinc-800 text-gold-500" data-id="element-70" data-mp="7lmvyi0g2xdx">
            <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-71" data-mp="7nzkje0pk5zy" />
          </span>
          {t.contactViber}
        </a>
        <a href="https://t.me/barbershop" target="_blank" rel="noopener noreferrer" className="contact-row bg-zinc-900 text-zinc-100 hover:bg-zinc-800 border-transparent" data-id="element-72" data-mp="gnckng2xzi80">
          <span className="contact-icon bg-zinc-800 text-gold-500" data-id="element-73" data-mp="qjz6a733edb3">
            <SendIcon className="h-5 w-5" aria-hidden="true" data-id="element-74" data-mp="lm7cf7iw0h49" />
          </span>
          {t.contactTelegram}
        </a>
      </div>
    </section>;
}